/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-24 19:08:41
 * @LastEditors: changfeng
 * @LastEditTime: 2024-09-27 14:25:57
 */
import { Button, Divider, message, Modal } from "antd";
import "./index.less";
import Right from "@/assets/icons/right.svg";
import { createSubscriptionOrder, upgradeSubscriptionOrder } from "@/api/modules/plan";
import { useTranslation } from "react-i18next";
import discountStandard from "@/assets/icons/subscription/discountStandard.png";
import discountProfessional from "@/assets/icons/subscription/discountProfessional.png";
import discountBusiness from "@/assets/icons/subscription/discountBusiness.png";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser } from "@/api/modules/user";
import { setCurrentUser } from "@/redux/modules/global/action";
import ContactUsButton from "@/pages/Subscription/Subscribe/contact-us-button";
import IconJump from "@/assets/icons/subscription/iconJump.png";
import SubscriptionModal from "@/pages/Subscription/Subscribe/component/SubscripeModal";
import { useNavigate } from "react-router-dom";
import { redirectHpp } from "@/components/airwallex/Hpp";
const SubscriptionPlan = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { currentUser, currentTeam } = useSelector(state => state.global);
	const [isOwner, setIsOwner] = useState(false);
	const [showDegradationModal, setShowDegradationModal] = useState(false);

	const [plan, setPlan] = useState();
	const [targetPlan, setTargetPlan] = useState();

	useEffect(() => {
		setPlan(currentUser.currentPlan);
	}, [currentUser]);

	useEffect(() => {
		setIsOwner(currentUser?.id === currentTeam?.ownerId);
	}, [currentUser, currentTeam]);

	const renderNavigateButton = () => {
		return (
			<Button
				className="ChooseButton"
				onClick={() => {
					navigate("/billing/history");
				}}
			>
				<span>{t("subscription.skip to billing")}</span>
				<img src={IconJump} style={{ marginLeft: "4px" }} />
			</Button>
		);
	};

	const renderStandardButton = () => {
		if (!isOwner) {
			return;
		}

		// if (!plan?.planId || plan?.isFreeUser) {
		if (!currentUser?.havePlan) {
			/** 未订阅or免费用户 */
			return (
				<Button
					className="ChooseButton"
					onClick={() => {
						setTargetPlan({
							planId: 1,
							planName: "Standard",
							isTrialing: false,
							trialDays: 0
						});
						setShowDegradationModal(true);
					}}
				>
					<span>{t("subscription.intro.standard.button")}</span>
				</Button>
			);
		}

		if (plan.isExpired) {
			// 套餐已过期，不需要判断之前是什么套餐，显示订阅按钮
			return (
				<Button
					className="ChooseButton"
					onClick={() => {
						setTargetPlan({
							planId: 1,
							planName: "Standard",
							isTrialing: false,
							trialDays: 0
						});
						setShowDegradationModal(true);
					}}
				>
					<span>{t("subscription.intro.standard.button")}</span>
				</Button>
			);
		} else {
			// 当前是标准套餐，显示为“当前套餐”，不可点击
			return renderNavigateButton();
		}
	};

	const renderProButton = () => {
		if (!isOwner) {
			return;
		}

		// if (!plan?.planId || plan.isFreeUser) {
		if (!currentUser?.havePlan) {
			/** 未订阅or免费用户 */
			return (
				<Button
					className="ChooseButton"
					onClick={() => {
						setTargetPlan({
							planId: 2,
							planName: "Standard",
							isTrialing: false,
							trialDays: 0
						});
						setShowDegradationModal(true);
					}}
				>
					<span>{t("subscription.intro.professional.button")}</span>
				</Button>
			);
		} else {
			return renderNavigateButton();
		}
	};

	const renderBusinessButton = () => {
		if (!isOwner) {
			return;
		}

		return (
			<ContactUsButton className="ChooseButton">
				<span>{t("subscription.intro.business.button")}</span>
			</ContactUsButton>
		);
	};

	const handleSubscribe = plan => {
		/**
		 * plan:1 | 2, **** 1:普通套餐，2: pro
		 */
		createSubscriptionOrder({
			planProductId: plan
		}).then(res => {
			console.log("Create Order", res);
			if (res.code === 200) {
				redirectHpp(res.data.paymentIntentId, res.data.clientSecret);
			}
		});
	};

	const handleUpgrade = () => {
		Modal.confirm({
			icon: null,
			title: t("subscription.upgrade.modal.title"),
			content: t("subscription.upgrade.modal.text"),
			okText: t("subscription.upgrade.modal.ok"),
			closable: true,
			maskClosable: true,
			width: 500,
			onOk() {
				upgradeSubscriptionOrder().then(res => {
					console.log("Upgrade Order", res);
					if (res.code === 200) {
						redirectHpp(res.data.paymentIntentId, res.data.clientSecret);
						message.success(t("message.upgrade.subscription.plan.success"));
						getCurrentUser().then(res => {
							dispatch(setCurrentUser(res.data));
						});
					}
				});
			}
		});
	};

	return (
		<div className="planContainer">
			<div className="new-user-try">
				<span className="new-user-try-text">🎁 {t("subscription.intro.subtitle1")}</span>
			</div>

			<div className="planHeaderContainer">
				<div className="planPageTitle">{t("subscription.intro.title")}</div>
				<div className="planPageDescribe">{t("subscription.intro.subtitle")}</div>
			</div>
			<div className="planPageCard">
				<div className="planCard">
					<div className="planCardHeader">
						<div className="planTitle">
							<div className="planTitleText">{t("subscription.intro.standard.title")}</div>
							{plan?.planId === 1 && (
								<div className="hadSubBox">
									<span className="hadSubscripe">{t("subscription.intro.button.currentPlan")}</span>
								</div>
							)}
						</div>
						<div className="planPrice">
							$15.99<span>/{t("subscription.intro.standard.timeUnits")}</span>
							<span className="originPrice">$29.99</span>
						</div>
					</div>
					<Divider />
					<div className="itemList">
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.standard.item1")}</span>
						</p>
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.standard.item2")}</span>
						</p>
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.standard.item3")}</span>
						</p>
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.standard.item4")}</span>
						</p>
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.standard.item5")}</span>
						</p>
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.standard.item6")}</span>
						</p>
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.standard.item7")}</span>
						</p>
						{/* <p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.standard.item8")}</span>
						</p> */}
					</div>

					{renderStandardButton()}

					<div className="discount">
						<img src={discountStandard} alt="" />
					</div>
				</div>
				<div className="planCard">
					<div className="planCardHeader">
						<div className="planTitle">
							<div className="planTitleText">{t("subscription.intro.professional.title")}</div>
							{plan?.planId === 2 && (
								<div className="hadSubBox">
									<span className="hadSubscripe">{t("subscription.intro.button.currentPlan")}</span>
								</div>
							)}
						</div>
						<div className="planPrice">
							$45.99<span>/{t("subscription.intro.professional.timeUnits")}</span>
							<span className="originPrice">$99.99</span>
						</div>
					</div>
					<Divider />
					<div className="itemList">
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.professional.item1")}</span>
						</p>
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.professional.item2")}</span>
						</p>
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.professional.item3")}</span>
						</p>
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.professional.item4")}</span>
						</p>
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.professional.item5")}</span>
						</p>
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.professional.item6")}</span>
						</p>
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.professional.item7")}</span>
						</p>
						{/* <p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.professional.item8")}</span>
						</p> */}
					</div>

					{renderProButton()}

					<div className="discount">
						<img src={discountProfessional} alt="" />
					</div>
					<div className="mostPopular">{t("subscription.intro.professional.mostPopular")}</div>
				</div>
				<div className="planCard">
					<div className="planCardHeader">
						<div className="planTitle">
							<div className="planTitleText">{t("subscription.intro.business.title")}</div>
							{plan?.planId === 3 && (
								<div className="hadSubBox">
									<span className="hadSubscripe">{t("subscription.intro.button.currentPlan")}</span>
								</div>
							)}
						</div>
						<div className="planPrice">
							$599<span>/{t("subscription.intro.business.timeUnits")}</span>
							<span className="originPrice">$999</span>
						</div>
					</div>
					<Divider />
					<div className="itemList">
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.business.item1")}</span>
						</p>
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.business.item2")}</span>
						</p>
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.business.item3")}</span>
						</p>
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.business.item4")}</span>
						</p>
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.business.item5")}</span>
						</p>
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.business.item6")}</span>
						</p>
						<p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.business.item7")}</span>
						</p>
						{/* <p className="planItems">
							<img src={Right} alt="" />
							<span>{t("subscription.intro.business.item8")}</span>
						</p> */}
					</div>
					{renderBusinessButton()}
					<div className="discount">
						<img src={discountBusiness} alt="" />
					</div>
				</div>
			</div>

			<SubscriptionModal
				open={showDegradationModal}
				plan={targetPlan}
				onCancel={() => {
					setShowDegradationModal(false);
				}}
			/>
		</div>
	);
};

export default SubscriptionPlan;
